import { callGetApiToServer } from '../callApi';

export async function listAllDropDownCourse(
  authtoken,
  skip,
  limit
) {
  try {
    let header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "authorization": "Berear " + authtoken
    }

    let endUrl = "v1/courses" + "/" + skip + "/" + limit;
    let responseData = await callGetApiToServer(header, "GET", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
